import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components

// index page sections


import {getStats} from "../../components/helpers/StatsHelpers";
import {SeoHelper} from "../../components/helpers/SeoHelper";

class CookiePolicy extends React.Component {
  state = {
    songBookCount: null
  };

  constructor(props) {
    super(props);
    getStats.call(this);
  }

  render() {
    return (
      <>
        <SeoHelper
            uri="/cookie-policy"
            title = "Cookie Policy | The Worship Bible"
            description={"Your information is important to us and we have a well defined cookie policy that lets you know what we use cookies for."}
        />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>cookie policy</span>
                      </h1>
                      {/*<p className="lead text-white">*/}
                      {/*  The design system comes with four pre-built pages to*/}
                      {/*  help you get started faster. You can change the text and*/}
                      {/*  images and you're good to go.*/}
                      {/*</p>*/}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="12">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          {/*<div className="icon icon-shape icon-shape-primary rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-check-bold" />*/}
                          {/*</div>*/}
                          {/*<div dangerouslySetInnerHTML={this.privacyPolicy} />*/}
                          <Row className="justify-content-center">
                            <p className="description mt-3">
                              <img src={require("../../assets/images/termly-logo.png")} alt="Termly"/>
                            </p>
                          </Row>
                          <div className="WordSection1">
                            <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pt-3 pb-3">
                              COOKIE POLICY
                            </h2>

                          <p className="MsoNormal"><b>Last updated&nbsp;April 04, 2025</b></p>

                            <p className="MsoNormal">
                              This Cookie Policy explains how The Worship Bible (<b>"Company," "we,"
                              "us,"</b> and <b>"our"</b>) uses cookies and similar technologies to recognise you when
                              you visit our website at <a
                                href="https://theworshipbible.church">theworshipbible.church</a> (<b>"Website"</b>). It
                              explains what these technologies are and why we use them, as well as your rights to
                              control our use of them.
                            </p>

                            <p className="MsoNormal">
                              In some cases we may use cookies to collect personal information, or that becomes personal
                              information if we combine it with other information.
                            </p>

                            <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary"><b>What are cookies?</b></h3>

                            <p className="MsoNormal">
                              Cookies are small data files that are placed on your computer or mobile device when you
                              visit a website. Cookies are widely used by website owners in order to make their websites
                              work, or to work more efficiently, as well as to provide reporting information.
                            </p>

                            <p className="MsoNormal">
                              Cookies set by the website owner (in this case, The Worship Bible) are called "first-party
                              cookies." Cookies set by parties other than the website owner are called "third-party
                              cookies." Third-party cookies enable third-party features or functionality to be provided
                              on or through the website (e.g., advertising, interactive content, and analytics). The
                              parties that set these third-party cookies can recognise your computer both when it visits
                              the website in question and also when it visits certain other websites.
                            </p>

                            <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary"><b>Why do we use cookies?</b></h3>

                            <p className="MsoNormal">
                              We use first- and third-party cookies for several reasons. Some cookies are required for
                              technical reasons in order for our Website to operate, and we refer to these as
                              "essential" or "strictly necessary" cookies. Other cookies also enable us to track and
                              target the interests of our users to enhance the experience on our Online Properties.
                              Third parties serve cookies through our Website for advertising, analytics, and other
                              purposes. This is described in more detail below.
                            </p>

                            <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary"><b>How can I control cookies?</b></h3>

                            <p className="MsoNormal">
                              You have the right to decide whether to accept or reject cookies. You can exercise your
                              cookie rights by setting your preferences in the Cookie Consent Manager. The Cookie
                              Consent Manager allows you to select which categories of cookies you accept or reject.
                              Essential cookies cannot be rejected as they are strictly necessary to provide you with
                              services.
                            </p>

                            <p className="MsoNormal">
                              The Cookie Consent Manager can be found in the notification banner and on our website. If
                              you choose to reject cookies, you may still use our website though your access to some
                              functionality and areas of our website may be restricted. You may also set or amend your
                              web browser controls to accept or refuse cookies.
                            </p>

                            <p className="MsoNormal">
                              The specific types of first- and third-party cookies served through our Website and the
                              purposes they perform are described in the table below (please note that the specific
                              cookies served may vary depending on the specific Online Properties you visit):
                            </p>

                            <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary"><b>Essential website cookies:</b></h3>

                            <p className="MsoNormal">
                              These cookies are strictly necessary to provide you with services available through our
                              Website and to use some of its features, such as access to secure areas. </p>

                            <p className="MsoNormal">
                              <table width="100%" border="1">
                                <tr>
                                  <td>
                                    <table width="100%">
                                      <tr>
                                        <td align="right">Name:</td>
                                        <td>__stripe_mid</td>
                                      </tr>
                                      <tr>
                                        <td align="right">Purpose:</td>
                                        <td>Fraud prevention and detection</td>
                                      </tr>
                                      <tr>
                                        <td width="10%" align="right">Provider:</td>
                                        <td>theworshipbible.church</td>
                                      </tr>
                                      <tr>
                                        <td width="10%" align="right">Service:</td>
                                        <td>Stripe <a href="https://stripe.com/en-nl/privacy" target="stripe">View
                                          Service Privacy Policy</a></td>
                                      </tr>
                                      <tr>
                                        <td width="10%" align="right">Type:</td>
                                        <td>http_cookie</td>
                                      </tr>
                                      <tr>
                                        <td width="10%" align="right">Expires in:</td>
                                        <td>11 months 30 days</td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>
                            </p>

                            <p className="MsoNormal">
                              <table width="100%" border="1">
                                <tr>
                                  <td>
                                    <table width="100%">
                                      <tr>
                                        <td align="right">Name:</td>
                                        <td>__stripe_mid</td>
                                      </tr>
                                      <tr>
                                        <td align="right">Purpose:</td>
                                        <td>Fraud prevention and detection</td>
                                      </tr>
                                      <tr>
                                        <td width="10%" align="right">Provider:</td>
                                        <td>theworshipbible.church</td>
                                      </tr>
                                      <tr>
                                        <td width="10%" align="right">Service:</td>
                                        <td>Stripe <a href="https://stripe.com/en-nl/privacy" target="stripe">View
                                          Service Privacy Policy</a></td>
                                      </tr>
                                      <tr>
                                        <td width="10%" align="right">Type:</td>
                                        <td>http_cookie</td>
                                      </tr>
                                      <tr>
                                        <td width="10%" align="right">Expires in:</td>
                                        <td>30 minutes</td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>
                            </p>

                            <p className="MsoNormal">
                              <table width="100%" border="1">
                                <tr>
                                  <td>
                                    <table width="100%">
                                      <tr>
                                        <td align="right">Name:</td>
                                        <td>m</td>
                                      </tr>
                                      <tr>
                                        <td align="right">Purpose:</td>
                                        <td>Tracks the user's session for Stripe</td>
                                      </tr>
                                      <tr>
                                        <td width="10%" align="right">Provider:</td>
                                        <td>m.stripe.com</td>
                                      </tr>
                                      <tr>
                                        <td width="10%" align="right">Service:</td>
                                        <td>Stripe <a href="https://stripe.com/en-nl/privacy" target="stripe">View
                                          Service Privacy Policy</a></td>
                                      </tr>
                                      <tr>
                                        <td width="10%" align="right">Type:</td>
                                        <td>server_cookie</td>
                                      </tr>
                                      <tr>
                                        <td width="10%" align="right">Expires in:</td>
                                        <td>1 year 11 months 29 days</td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>
                            </p>

                            <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary"><b>How can I control cookies on my browser?</b></h3>

                            <p className="MsoNormal">
                              As the means by which you can refuse cookies through your web browser controls vary from
                              browser to browser, you should visit your browser's help menu for more information. The
                              following is information about how to manage cookies on the most popular browsers:
                            </p>
                            <ul style={{marginTop: 0 + 'cm'}} type="square">
                              <li className="MsoNormal"><a
                                  href="https://support.google.com/chrome/answer/95647#zippy=%2Callow-or-block-cookies"
                                  target="_blank" rel="noreferrer">Chrome</a></li>
                            </ul>
                            <ul style={{marginTop: 0 + 'cm'}} type="square">
                              <li className="MsoNormal"><a
                                  href="https://support.microsoft.com/en-us/windows/manage-cookies-in-microsoft-edge-view-allow-block-delete-and-use-168dab11-0753-043d-7c16-ede5947fc64d"
                                  target="_blank" rel="noreferrer">Internet Explorer</a></li>
                            </ul>
                            <ul style={{marginTop: 0 + 'cm'}} type="square">
                              <li className="MsoNormal"><a
                                  href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop?redirectslug=enable-and-disable-cookies-website-preferences&redirectlocale=en-US"
                                  target="_blank" rel="noreferrer">Firefox</a></li>
                            </ul>
                            <ul style={{marginTop: 0 + 'cm'}} type="square">
                              <li className="MsoNormal"><a
                                  href="https://support.apple.com/en-ie/guide/safari/sfri11471/mac" target="_blank"
                                  rel="noreferrer">Safari</a></li>
                            </ul>
                            <ul style={{marginTop: 0 + 'cm'}} type="square">
                              <li className="MsoNormal"><a
                                  href="https://support.microsoft.com/en-us/windows/microsoft-edge-browsing-data-and-privacy-bb8174ba-9d73-dcf2-9b4a-c582b4e640dd"
                                  target="_blank" rel="noreferrer">Edge</a></li>
                            </ul>
                            <ul style={{marginTop: 0 + 'cm'}} type="square">
                              <li className="MsoNormal"><a href="https://help.opera.com/en/latest/web-preferences/"
                                                           target="_blank" rel="noreferrer">Opera</a></li>
                            </ul>

                            <p className="MsoNormal">
                              In addition, most advertising networks offer you a way to opt out of targeted advertising.
                              If you would like to find out more information, please visit:
                            </p>
                            <ul style={{marginTop: 0 + 'cm'}} type="square">
                              <li className="MsoNormal"><a href="https://optout.aboutads.info/?c=2&lang=EN"
                                                           target="_blank" rel="noreferrer">Digital Advertising
                                Alliance</a></li>
                            </ul>
                            <ul style={{marginTop: 0 + 'cm'}} type="square">
                              <li className="MsoNormal"><a href="https://youradchoices.ca/" target="_blank"
                                                           rel="noreferrer">Digital Advertising Alliance of Canada</a>
                              </li>
                            </ul>
                            <ul style={{marginTop: 0 + 'cm'}} type="square">
                              <li className="MsoNormal"><a href="https://www.youronlinechoices.com/" target="_blank"
                                                           rel="noreferrer">European Interactive Digital Advertising
                                Alliance</a></li>
                            </ul>

                            {/*<p className="MsoNormal"><b>What about other tracking technologies, like web beacons?</b>*/}
                            {/*</p>*/}

                            {/*<p className="MsoNormal">*/}
                            {/*  Cookies are not the only way to recognise or track visitors to a website. We may use*/}
                            {/*  other, similar technologies from time to time, like web beacons (sometimes called*/}
                            {/*  "tracking pixels" or "clear gifs"). These are tiny graphics files that contain a unique*/}
                            {/*  identifier that enables us to recognise when someone has visited our Website or opened an*/}
                            {/*  email including them. This allows us, for example, to monitor the traffic patterns of*/}
                            {/*  users from one page within a website to another, to deliver or communicate with cookies,*/}
                            {/*  to understand whether you have come to the website from an online advertisement displayed*/}
                            {/*  on a third-party website, to improve site performance, and to measure the success of email*/}
                            {/*  marketing campaigns. In many instances, these technologies are reliant on cookies to*/}
                            {/*  function properly, and so declining cookies will impair their functioning.*/}
                            {/*</p>*/}

                            {/*<p className="MsoNormal"><b>Do you use Flash cookies or Local Shared Objects?</b></p>*/}

                            {/*<p className="MsoNormal">*/}
                            {/*  Websites may also use so-called "Flash Cookies" (also known as Local Shared Objects or*/}
                            {/*  "LSOs") to, among other things, collect and store information about your use of our*/}
                            {/*  services, fraud prevention, and for other site operations.*/}
                            {/*</p>*/}

                            {/*<p className="MsoNormal">*/}
                            {/*  If you do not want Flash Cookies stored on your computer, you can adjust the settings of*/}
                            {/*  your Flash player to block Flash Cookies storage using the tools contained in the Website*/}
                            {/*  Storage Settings Panel. You can also control Flash Cookies by going to the Global Storage*/}
                            {/*  Settings Panel and following the instructions (which may include instructions that*/}
                            {/*  explain, for example, how to delete existing Flash Cookies (referred to "information" on*/}
                            {/*  the Macromedia site), how to prevent Flash LSOs from being placed on your computer without*/}
                            {/*  your being asked, and (for Flash Player 8 and later) how to block Flash Cookies that are*/}
                            {/*  not being delivered by the operator of the page you are on at the time).*/}
                            {/*</p>*/}

                            {/*<p className="MsoNormal">*/}
                            {/*  Please note that setting the Flash Player to restrict or limit acceptance of Flash Cookies*/}
                            {/*  may reduce or impede the functionality of some Flash applications, including, potentially,*/}
                            {/*  Flash applications used in connection with our services or online content.*/}
                            {/*</p>*/}

                            {/*<p className="MsoNormal"><b>Do you serve targeted advertising?</b></p>*/}

                            {/*<p className="MsoNormal">*/}
                            {/*  Third parties may serve cookies on your computer or mobile device to serve advertising*/}
                            {/*  through our Website. These companies may use information about your visits to this and*/}
                            {/*  other websites in order to provide relevant advertisements about goods and services that*/}
                            {/*  you may be interested in. They may also employ technology that is used to measure the*/}
                            {/*  effectiveness of advertisements. They can accomplish this by using cookies or web beacons*/}
                            {/*  to collect information about your visits to this and other sites in order to provide*/}
                            {/*  relevant advertisements about goods and services of potential interest to you. The*/}
                            {/*  information collected through this process does not enable us or them to identify your*/}
                            {/*  name, contact details, or other details that directly identify you unless you choose to*/}
                            {/*  provide these.*/}
                            {/*</p>*/}

                            <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary"><b>How often will you update this Cookie Policy?</b></h3>

                            <p className="MsoNormal">
                              We may update this Cookie Policy from time to time in order to reflect, for example,
                              changes to the cookies we use or for other operational, legal, or regulatory reasons.
                              Please therefore revisit this Cookie Policy regularly to stay informed about our use of
                              cookies and related technologies.
                            </p>

                            <p className="MsoNormal">
                              The date at the top of this Cookie Policy indicates when it was last updated.
                            </p>

                            <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary"><b>Where can I get further information?</b></h3>

                            <p className="MsoNormal">If you have any questions about our use of cookies or other
                              technologies, please email us at admin@theworshipbible.church.
                            </p>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        {/*</main>*/}

      </>
    );
  }
}

export default CookiePolicy;
